<template>
  <div class="panel-item first-panel">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>订单监控</div>
    </div>

    <div class="cards-box">
      <div class="card-item">
        <div class="num">{{ datas.unconfirmed?datas.unconfirmed:0 }}</div>
        <div class="label">未确认</div>
      </div>
      <div class="card-item">
        <div class="num">{{ datas.wait_pay?datas.wait_pay:0 }}</div>
        <div class="label">待尾款</div>
      </div>
      <div class="card-item">
        <div class="num">{{ datas.wait_deliver?datas.wait_deliver:0 }}</div>
        <div class="label">待发货</div>
      </div>
      <div class="card-item">
        <div class="num">{{ datas.partial_deliver?datas.partial_deliver:0 }}</div>
        <div class="label">部分发货</div>
      </div>
      <div class="card-item">
        <div class="num">{{ datas.delivered?datas.delivered:0 }}</div>
        <div class="label">已发货</div>
      </div>
      <div class="card-item">
        <div class="num">{{ datas.signed?datas.signed:0 }}</div>
        <div class="label">已签收</div>
      </div>
      <div class="card-item">
        <div class="num">{{ datas.completed?datas.completed:0 }}</div>
        <div class="label">已完成</div>
      </div>
      <div class="card-item">
        <div class="num">{{ datas.refunded?datas.refunded:0 }}</div>
        <div class="label">已退款</div>
      </div>
      <div class="card-item">
        <div class="num">{{ datas.closed?datas.closed:0 }}</div>
        <div class="label">已关闭</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    datas: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},

}
</script>

<style lang="scss" scoped>

.panel-item {
  width: 100%;
  height: 310px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  .title_name {
    padding: 30px 0 20px 100px;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
  }


}

.cards-box {
  height: 300px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  justify-items: center;

  .card-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .num {
      font-size: 30px;
      color: #0183cd;
    }

    .label {
      font-size: 18px;
      color: white;
    }
  }
}


</style>